import React from 'react';
import { useOrderSettings } from '../../hooks';
import './style.scss';
import HelpInformation from '../HelpInformation';

export default function OrderSettings({
  values: externalValues,
  onChange,
  onReset,
  onDelete,
  orderCount = 0,
  itemError,
}) {
  const {
    values: currentValues,
    isHidden,
    toggleHidden,
    handleFieldChange,
    handleReset,
    isEditMode,
    validationErrors,
  } = useOrderSettings({ values: externalValues, onChange, onReset, orderCount });

  const stockError = itemError?.maxQuantity?.message || validationErrors.availableStock;
  const limitError = itemError?.limitPerOrder?.message || validationErrors.limitPerOrder;

  return (
    <div className="option-panel">
      <div className="option-panel-header">
        <div className="option-panel-title">
          Order Settings
          {isEditMode && Number(orderCount) > 0 && (
            <span style={{ fontSize: '11px', color: '#009A97', marginLeft: '6px', fontWeight: 'normal' }}>
              ({orderCount} ordered)
            </span>
          )}
          <HelpInformation content="Available stock: the total number of this product you have to sell across the whole event. Limit per order: the most a single buyer can get in one order. Minimum per order: the smallest amount someone has to buy if they want any at all."/>
        </div>
        <div className="option-panel-actions">
          <span
            className="btn-action-text"
            onClick={handleReset}
            role="button"
            tabIndex={0}
          >
            Reset
          </span>
          <span
            className="btn-action-text btn-action-text--highlight"
            onClick={toggleHidden}
            role="button"
            tabIndex={0}
          >
            {isHidden ? 'Show' : 'Hide'}
          </span>
          {onDelete && (
            <div
              className="icon-btn danger"
              title="Delete"
              onClick={onDelete}
              role="button"
              tabIndex={0}
            >
              <svg
                width="11"
                height="11"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <polyline points="3 6 5 6 21 6" />
                <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
              </svg>
            </div>
          )}
        </div>
      </div>

      {!isHidden && (
        <div className="option-body">
          <div className="option-field">
            <span>Available stock</span>
            <input
              type="number"
              value={currentValues.availableStock ?? ''}
              onChange={(e) => handleFieldChange('availableStock', e.target.value)}
            />
          </div>
          {stockError && (
            <div style={{ color: '#E24B4A', fontSize: '11px', marginTop: '2px', marginBottom: '6px' }}>
              {stockError}
            </div>
          )}

          <div className="option-field">
            <span>Limit per order</span>
            <input
              type="number"
              value={currentValues.limitPerOrder ?? ''}
              onChange={(e) => handleFieldChange('limitPerOrder', e.target.value)}
            />
          </div>
          {limitError && (
            <div style={{ color: '#E24B4A', fontSize: '11px', marginTop: '2px', marginBottom: '6px' }}>
              {limitError}
            </div>
          )}

          <div className="option-field">
            <span>Minimum per order</span>
            <input
              type="number"
              value={currentValues.minimumPerOrder ?? ''}
              onChange={(e) => handleFieldChange('minimumPerOrder', e.target.value)}
            />
          </div>
        </div>
      )}
    </div>
  );
}
